import { Button } from "components/UI/Buttons/Button";

import Link from "next/link";

import styles from "./ArticleAuthorCard.module.scss";
import { WrappedIcon } from "components/UI/WrappedIcon";
import { EditorContent } from "../../article/EditorContent";
import { useArticleSinglePageContext } from "@/helpers/contexts/ArticleSinglePageContext";
import { EditorContentData } from "@/components/pages/article/EditorContent/types";
import FacebookIcon from "public/img/icons/svg/facebook.svg";
import InstagramIcon from "public/img/icons/svg/instagram.svg";
import Image from "next/image";
import cn from "classnames";
import cs from "@/styles/modules/card.module.scss";

export const ArticleAuthorCard = () => {
  const contextData = useArticleSinglePageContext();
  if (!contextData) return null;
  const { article } = contextData;
  const { categories } = article;

  const author = categories?.data?.[0]?.attributes?.author?.data?.attributes;

  if (!author) return null;

  let authorBio: EditorContentData | undefined;

  try {
    authorBio = JSON.parse(author.bio?.short || "");
  } catch (err) {}

  const authorImage = author?.avatar?.data?.attributes;

  return (
    <div className={cn(cs.cardGlass, styles.wrapper)}>
      <div className={styles.top}>
        <div className={styles.info}>
          <Link href={`/authors/${author.slug}`} className={styles.photoWrapper} prefetch={false}>
            {authorImage && (
              <Image
                src={authorImage.url}
                alt={authorImage.alternativeText || ""}
                className={styles.photo}
                width={54}
                height={54}
              />
            )}
          </Link>
          <div className={styles.nameWrapper}>
            <Link href={`/authors/${author.slug}`} className={styles.name} prefetch={false}>
              {author.fullName}
            </Link>
            <Button className={styles.label} href="/authors" type="primary" outline size="xs">
              Author
            </Button>
          </div>
        </div>
        {/*<div className={styles.socials}>*/}
        {/*  {author.social?.linkedin && (*/}
        {/*    <div className={styles.socialsItem}>*/}
        {/*      <a href={author.social.linkedin} rel="nofollow noreferrer" target="_blank">*/}
        {/*        <WrappedIcon icon="linkdin" type="primary" />*/}
        {/*      </a>*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*  {author.social?.instagram && (*/}
        {/*    <div className={styles.socialsItem}>*/}
        {/*      <a href={author.social.instagram} rel="nofollow" target="_blank noreferrer">*/}
        {/*        <WrappedIcon icon={InstagramIcon} type="primary" />*/}
        {/*      </a>*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*  {author.social?.facebook && (*/}
        {/*    <div className={styles.socialsItem}>*/}
        {/*      <a href={author.social.facebook} rel="nofollow noreferrer" target="_blank">*/}
        {/*        <WrappedIcon icon={FacebookIcon} type="primary" />*/}
        {/*      </a>*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*</div>*/}
      </div>
      <div className={styles.content}>{authorBio && <EditorContent data={authorBio} />}</div>
      <Button type="white" outline href={`/authors/${author.slug}`}>
        Explore author’s articles
      </Button>
    </div>
  );
};
